<script>
  import {createEventDispatcher, onMount} from "svelte";

  const dispatch = createEventDispatcher();

  let notifyLoaded = () => {
    dispatch("memberDetailsLoaded");
  };

  onMount(() => {
    // once the content load, invoke notifyLoaded. This next line is for an example only, simulating loading delay of 1s
    setTimeout(notifyLoaded, 1000);
  });
</script>

<!-- Circles User Info -->
<div class="col20 f-left flex align-center">
  <h3>Circle Analytics</h3>
  <div class="custom-dropdown ml-15">
    <div class="flex align-center custom-dropdown-button circle-effect blue">
      Circle Name <span class="material-icons">keyboard_arrow_down</span>
    </div>
  </div>
</div>
<div class="flex col20 f-left mb-25 mt-15 store-section-analytics-warapper double-row-analytics analytics-smaller-font"
     style="background: #f5f6fa;">
  <div class="analytics-box analytics-box-small">
    <h3>Circles</h3>
    <h2 class="col20 f-left f-19 gray-text"><b>Circle Name</b></h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3>Circle Payments</h3>
    <h2 class="col20 f-left f-19 gray-text">
      <b>7</b>
    </h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3>Circle Revenue</h3>
    <h2 class="col20 f-left f-19 gray-text">
      <b>$82.00</b>
      <span>~$17 per payment</span>
    </h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3>Join Date</h3>
    <h2 class="col20 f-left f-19 gray-text">
      <b>January 13, 2023</b>
    </h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3>Content Complete</h3>
    <h2 class="col20 f-left f-19 gray-text">
      <b>10/16</b>
    </h2>
  </div>
</div>

<div class="col20 f-left">
  <div class="col20 f-left mb-15 flex align-center">
    <h3 class="roboto title-line">Circles</h3>
    <a href="" class="small-button blue with-icon rounded-effect">Manage Circles</a>
  </div>
  <div class="col20 f-left">
    <div class="filter-option" style="background: rgb(236, 237, 243) none repeat scroll 0% 0%;">
      <span>Circle Name</span>
      <a class="filter-delete">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 357 357" xml:space="preserve"><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></svg>
      </a>
    </div>
    <div class="filter-option" style="background: rgb(236, 237, 243) none repeat scroll 0% 0%;">
      <span>Circle Name</span>
      <a class="filter-delete">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 357 357" xml:space="preserve"><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></svg>
      </a>
    </div>
    <div class="filter-option" style="background: rgb(236, 237, 243) none repeat scroll 0% 0%;">
      <span>Circle Name</span>
      <a class="filter-delete">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 357 357" xml:space="preserve"><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></svg>
      </a>
    </div>
  </div>
</div>

<div class="col20 f-left mt-25">
  <div class="upper-navigation upper-navigation-full inner-upper-nav mb-25">
    <ul>
      <li><a class="active">Tracked Content</a></li>
      <li><a>Paid Content</a></li>
    </ul>
  </div>

  <div class="scrollable-table orders-scrollable-tablee scrollable-table-design strnger-border multi-level-table mb-25">
    <table style="margin-top: 0px;">
      <thead>
      <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
        <th class="checkbox-table"></th>
        <th class="flex-none mw-240" style="padding-left: 20px;"><a>Name</a></th>
        <th class="flex-none mw-100"><a>Progress</a></th>
        <th class="flex-none mw-120"><a>Status</a></th>
        <th class="flex-none mw-120"><a>Enrollment Date</a></th>
        <th class="flex-none mw-120"><a>Completion Date</a></th>
      </tr>
      </thead>
      <tbody style="height: auto;">
      <tr class="flex flex-row align-center mb-0 mt-10">
        <td class="checkbox-table"><a href="" class="table-expand-btn"><span class="material-icons-outlined"> do_not_disturb_on </span></a>
        </td>
        <td class="flex-none mw-240" style="padding-left: 20px;">Circle Name</td>
        <td class="flex-none mw-100"><a>8/10</a></td>
        <td class="flex-none mw-120"><span class="pay-status not-paid">Not Complete</span></td>
        <td class="flex-none mw-140">March 18, 2023</td>
        <td class="flex-none mw-140">-</td>
      </tr>
      <tr class="inner-table-wrapper">
        <td>
          <table class="inner-table" style="margin-top: 0px;">
            <thead>
            <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
              <th class="flex-none mw-240" style="padding-left: 20px;"><a>Page Name</a></th>
              <th class="flex-none mw-120"><a>Status</a></th>
              <th class="flex-none"><a>Completion Date</a></th>
            </tr>
            </thead>
            <tbody style="height: auto;">
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-300" style="padding-left: 20px;"><b class="inner-circle-separator">Inner Circle
                Name (3/5) ↓</b></td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-300" style="padding-left: 20px;"><b class="inner-circle-separator">Inner Circle
                Name (3/5) ↓</b></td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr class="flex flex-row align-center mb-0 mt-10">
        <td class="checkbox-table"><a href="" class="table-expand-btn"><span class="material-icons-outlined"> do_not_disturb_on </span></a>
        </td>
        <td class="flex-none mw-240" style="padding-left: 20px;">Inner Circle Name</td>
        <td class="flex-none mw-100"><a>8/10</a></td>
        <td class="flex-none mw-120"><span class="pay-status not-paid">Not Complete</span></td>
        <td class="flex-none mw-140">March 18, 2023</td>
        <td class="flex-none mw-140">-</td>
      </tr>
      <tr class="inner-table-wrapper">
        <td>
          <table class="inner-table" style="margin-top: 0px;">
            <thead>
            <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
              <th class="flex-none mw-240" style="padding-left: 20px;"><a>Page Name</a></th>
              <th class="flex-none mw-120"><a>Status</a></th>
              <th class="flex-none"><a>Completion Date</a></th>
            </tr>
            </thead>
            <tbody style="height: auto;">
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            <tr class="flex flex-row align-center inner-table-row" data-id="99">
              <td class="flex-none mw-240" style="padding-left: 20px;">Content Page Name</td>
              <td class="flex-none mw-120"><span class="pay-status paid">Complete</span></td>
              <td class="flex-none">March 20, 2023</td>
            </tr>
            </tbody>
          </table>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="scrollable-table orders-scrollable-table scrollable-table-design strnger-border">
    <table style="margin-top: 0px;">
      <thead>
      <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
        <th class="flex-none mw-300" style="padding-left: 20px;"><a>Name</a></th>
        <th class="flex-none mw-120">Price</th>
        <th class="flex-none"><a>Type</a></th>
        <th class="flex-none mw-120"><a>Status</a></th>
        <th class="flex-none"><a>Purchase Date</a></th>
      </tr>
      </thead>
      <tbody style="height: auto;">
      <tr class="flex flex-row align-center" data-id="99">
        <td class="flex-none mw-300" style="padding-left: 20px;">Inner Circle Name</td>
        <td class="flex-none mw-120">$9</td>
        <td class="flex-none"><a>Inner Circle</a></td>
        <td class="flex-none mw-120"><span class="pay-status paid">Paid</span></td>
        <td class="flex-none">March 18, 2023</td>
      </tr>
      <tr class="flex flex-row align-center" data-id="99">
        <td class="flex-none mw-300" style="padding-left: 20px;">Inner Circle Name</td>
        <td class="flex-none mw-120">$9</td>
        <td class="flex-none"><a>Inner Circle</a></td>
        <td class="flex-none mw-120"><span class="pay-status paid">Paid</span></td>
        <td class="flex-none">March 18, 2023</td>
      </tr>
      <tr class="flex flex-row align-center" data-id="99">
        <td class="flex-none mw-300" style="padding-left: 20px;">Inner Circle Name > Page Name</td>
        <td class="flex-none mw-120">$9</td>
        <td class="flex-none">Page</td>
        <td class="flex-none mw-120"><span class="pay-status not-paid">+ Give Access</span></td>
        <td class="flex-none">-</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Circles User Info -->